<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <form class="my-2 my-lg-0">
                    <button type="button" class="btn btn-warning" @click="goToMachineSheetForm(null)">
                        <icon name="plus"></icon>
                        เพิ่มเครื่องผลิตชีท
                    </button>
                </form>
            </div>
        </nav>
        <div>
            <div class="table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ชื่อเครื่อง</th>
                        <th scope="col">รายละเอียดเครื่อง</th>
                        <th scope="col">แก้ไข</th>


                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in sheetMachineList">
                        <td>
                            <template v-if="data.name">
                                {{data.name}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.description">
                                {{data.description}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <a @click="goToMachineSheetForm(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!---pagination--->
        <div v-if="sheetMachineList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getMachinePage">
            </vue-pagination>
        </div>
        <br/>
        <!--<pre class="alert-danger">{{sheetMachineList}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";

    export default {
        components: {VuePagination},
        name: "machine-sheet-list",
        created(){
            this.$store.dispatch("MachineSheet/getMachine")
        },
        computed:{
            ...mapState({
                sheetMachineList : state=>{
                    return state.MachineSheet.machine_sheet_list
                },
                dataPaginate:state=>{
                    return state.MachineSheet.dataPaginate;
                },
            })
        },
        methods:{
            getMachinePage(){
                const page = this.dataPaginate.current_page;
                this.$store.dispatch('MachineSheet/getMachine',page)
            },
            goToMachineSheetForm(id){
                if(id){
                    this.$store.dispatch("MachineSheet/showMachineById",id);
                }
                else{
                    this.$store.dispatch("MachineSheet/clearForm");
                }
                this.$router.push("/machine-sheet-form")
            }
        }
    }
</script>

<style scoped>

</style>